module.exports = __webpack_public_path__ + "static/media/video-bak.20b71e3e.webm";